export default "__VITE_ASSET__RwHQhI32__"